<template>
  <div
    id="select-extras"
    class="b-4"
  >
    <div class="col-heading">
      <h3 class="mb-4">
        Travel extras
      </h3>
    </div>
    <div class="form-group card-container">
      <div
        v-if="pending === true"
        class="travel-extras__list col-12 row"
      >
        <div
          v-for="(n, index) in 2"
          :key="index"
          class="travel-extras__item col-md-12 placeholder-item"
        >
          <div class="travel-extra__summary-wrapper">
            <div class="travel-extra__summary">
              <div class="travel-extra__header">
                <div class="travel-extra__title-wrapper">
                  <h3 class="travel-extra__title" />
                  <p class="travel-extra__price" />
                </div>
              </div>
              <div class="row">
                <div class="col-md-12 travel-extra__description">
                  <ul>
                    <li />
                    <li />
                    <li />
                  </ul>
                </div>
                <div class="col-md-12 travel-extra__values">
                  <div class="form-group">
                    <label />
                    <div class="input-wrapper">
                      <span class="form-control" />
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="travel-extra__additional-accordion">
              <div class="travel-extra__additional-button">
                <span class="btn btn-block" />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        v-if="pending === false && extraOptions.length === 0"
        class="alert alert-danger mt-5"
        role="alert"
      >
        <h3 class="mb-3">
          No travel extras found!
        </h3>
        <p>Change the criteria above, if possible, and try again.</p>
      </div>
      <div class="travel-extras__list col-12 row">
        <ExtraOption
          v-for="(extraOption, index) in extraOptions"
          :key="index"
          :disabled="disabled"
          :extra="extraOption"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import ExtraOption from './ExtraOption'

export default {
    name: 'SelectTravelExtras',
    components: {
        ExtraOption
    },
    props: {
        disabled: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        ...mapState({
            extraOptions: state => state.extra.extras,
            pending: state => state.extra.pending
        })
    }
}
</script>
